export const FEATURE_NAME = '@zerops/zerops/core/process-base';
